import StarIcon from '@material-ui/icons/Star';
import MailIcon from '@material-ui/icons/Mail';
import ScheduleIcon from '@material-ui/icons/Schedule';
import TodayIcon from '@material-ui/icons/Today';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import React from 'react';

export default [
  {id: 120, name: 'All', alias: 'all', icon: <AllInboxIcon />},
  {id: 121, name: 'Starred', alias: 'starred', icon: <StarIcon />},
  {id: 122, name: 'Priority', alias: 'priority', icon: <MailIcon />},
  {id: 123, name: 'Scheduled', alias: 'scheduled', icon: <ScheduleIcon />},
  {id: 124, name: 'Today', alias: 'today', icon: <TodayIcon />},
  {id: 125, name: 'Completed', alias: 'completed', icon: <DoneIcon />},
  {id: 126, name: 'Deleted', alias: 'deleted', icon: <DeleteIcon />},
];
